module.exports = __webpack_public_path__ + "static/media/Kendo Fighter.bfc1bfbb.jpg";